import * as yup from 'yup'

export const formValidationSchema = [
  // Step 0: Email y contraseñas
  yup.object({
    email: yup.string().required('Campo obligatorio').email('Debe ingresar un email válido'),
    password: yup.string().required('Campo obligatorio').min(8, 'La contraseña debe contener al menos 8 caracteres'),
    repeatPassword: yup
      .string()
      .required('Campo obligatorio')
      .oneOf([yup.ref('password')], 'Las contraseñas no coinciden'),
  }),

  // Step 1: Datos personales
  yup.object({
    firstname: yup.string().required('Campo obligatorio'),
    lastname: yup.string().required('Campo obligatorio'),
    mobile: yup
      .string()
      .test('maxLen', 'Este campo debe tener máximo 20 caracteres.', (val) => val.length <= 20)
      .test(
        'without_0_15',
        'Debe ir con característica, sin 0 y sin 15. Ejemplo: 1156789012.',
        (val) => !/^(15|0)/.test(val),
      )
      .required(),
    category: yup.string().notOneOf(['-'], 'Seleccione una categoría válida').required('Campo obligatorio'),
    centreName: yup.string().required('Campo obligatorio'),
  }),
]
